import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M41.15 3.88V1.69995L33.78 2.78992L26.41 1.69995V3.88L1.59998 7.54993C1.59998 7.54993 4.63997 28.85 25.47 23.46H26.41H41.15H42.09C62.92 28.84 65.96 7.54993 65.96 7.54993L41.15 3.88Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
